import { useCallback, useEffect, useState } from "react";

import CargaSelecaoService from "../main/services/CargaSelecaoService";

// Textos de ajuda (hint) dos campos. Compartilhados entre Cadastrar, Editar e
// Visualizar para o texto não divergir entre as telas.

// Serviço de Acolhimento
export const HINT_CNPJ_PROPRIO =
  "Informe este campo somente se o serviço de acolhimento possuir CNPJ próprio, diferente do CNPJ da entidade mantenedora.";

export const HINT_CNPJ_MANTENEDORA =
  "Informe o CNPJ da instituição responsável pela manutenção do serviço de acolhimento, como a Prefeitura ou entidade mantenedora, caso o serviço não possua CNPJ próprio. Este CNPJ pode estar vinculado a mais de um serviço.";

export const HINT_RESPONSAVEL_INFORMACOES =
  "O responsável pelas informações deverá ser um dos membros cadastrados " +
  "e em atividade como Equipe de referência ou Demais profissionais do serviço.";

// Criança e Adolescente
export const HINT_PPCAAM =
  "O Programa de Proteção a Crianças e Adolescentes Ameaçados de Morte - PPCAAM, consiste em uma política de proteção à vida de crianças e adolescentes em ameaça iminente de morte.";

export const HINT_PORTAL_EXTRAJUDICIAL =
  "Informações sobre registros de nascimentos e óbitos podem ser consultadas de forma on-line e gratuita pela página da Corregedoria Geral da Justiça do Tribunal de Justiça do Rio de Janeiro, através do Portal Extrajudicial. A plataforma permite que o usuário verifique de forma rápida em qual Serviço Extrajudicial se encontra o registro de nascimento ou óbito, facilitando assim a obtenção de segundas vias de certidões. O sistema permite aos cidadãos, aos órgãos judiciais e demais órgãos públicos a obtenção de informações relativas a registros de nascimento e óbito realizados em todo o estado desde agosto de 2007.";

export const HINT_COMPARTILHAR_IRMAOS =
  "Ao compartilhar um processo/procedimento com irmão(s), todas as informações serão importadas para ficha do(s) irmão(s) e as atualizações serão feitas de forma simultânea, ou seja, ao acessar qualquer uma das fichas e atualizar as informações sobre um processo/procedimento compartilhado, automaticamente essas informações também serão atualizadas na(s) ficha(s) do(s) irmão(s). Caso o processo/procedimento seja descompartilhado, as informações serão excluídas somente da ficha descompartilhada.";

// O nome do gênero chega em formatos diferentes conforme a tela ("Não
// Declarado", "NÃO DECLARADO") — compara sem caixa e sem acento.
const normalizarGenero = (texto) =>
  (texto || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

// A carga de gêneros é buscada uma vez e reaproveitada — o hook é usado em
// componentes que se repetem na tela (ex.: cada movimentação).
let cargaGeneros;
const buscarDescricoesGenero = () => {
  if (!cargaGeneros) {
    cargaGeneros = CargaSelecaoService.getGeneros()
      .then((res) =>
        Object.fromEntries(
          (res.data || []).map((genero) => [
            normalizarGenero(genero?.genero),
            genero?.descricao,
          ]),
        ),
      )
      .catch((erro) => {
        cargaGeneros = undefined;
        throw erro;
      });
  }
  return cargaGeneros;
};

// Hint de gênero no Visualizar: a mesma descrição exibida no select de gênero
// do Cadastrar/Editar, vinda da carga de gêneros. Devolve uma função
// nome -> descrição (undefined quando o gênero não tem descrição cadastrada).
export function useDescricaoGenero() {
  const [descricoes, setDescricoes] = useState({});

  useEffect(() => {
    let ativo = true;
    buscarDescricoesGenero()
      .then((mapa) => ativo && setDescricoes(mapa))
      .catch((erro) => console.log(erro));
    return () => {
      ativo = false;
    };
  }, []);

  return useCallback(
    (nome) => descricoes[normalizarGenero(nome)],
    [descricoes],
  );
}
